(ns ui.view.grid-opensearch.columns-modal.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.grid-opensearch.model :as model]))

(rf/reg-sub
 ::modal
 (fn [db [_ grid-id]]
   (get-in db (model/columns-modal-full-path grid-id))))
